<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <span class="headline"> Restituição de valores ao segurado</span>
    </v-card-title>

    <v-card-text class="py-5 px-4">
      <v-layout row wrap v-if="page === 1">
        <v-layout wrap>
          <v-layout>
            <v-flex class="themeGrey--text" pb-3
              >Selecione o(s) endosso(s) a restituir</v-flex
            >
          </v-layout>
          <v-layout>
            <v-flex class="body-2"> RESTITUIR </v-flex>
            <v-flex class="body-2"> SITUAÇÃO </v-flex>
            <v-flex class="body-2"> VLR. RESTITUIÇÃO </v-flex>
            <v-flex class="body-2"> QTD. ÍTENS </v-flex>
            <v-flex class="body-2"> N. EMISSÃO ENDOSSO </v-flex>
            <v-flex class="body-2">N. ENDOSSO RESTITUIÇÃO</v-flex>
          </v-layout>
          <v-layout row column>
            <v-layout
              row
              align-center
              wrap
              v-for="item in restituivelList"
              :key="item.numeroRevisao"
            >
              <v-flex style="text-align: center">
                <input
                  type="checkbox"
                  v-model="item.selected"
                  @click="salvarNumeroRevisao(item.numeroRevisao)"
                  :disabled="habilitarCheckbox && !verificarItemMesmo(item.numeroRevisao)">
                  
                
              </v-flex>
              
              <v-flex md2 class="dados-restituicao">
                {{ item.restituido === false ? "PENDENTE" : "RESTITUIDO" }}
              </v-flex>

              <v-flex md2 align-center> R$ {{ item.totalRestituicao }} </v-flex>

              <v-flex md1 class="dados-restituicao">
                {{ item.qtdItens }}
              </v-flex>

              <v-flex md3 class="dados-restituicao">
                {{ item.numeroEndosso || "-" }}
              </v-flex>

              <v-flex md3 class="dados-restituicao">
                {{ item.numeroEndossoRestituicao || "-" }}</v-flex
              >
            </v-layout>
          </v-layout>
        </v-layout>

        <v-layout row column>
          <v-layout py-3>
            <v-flex class="themeGrey--text">Cálculo de restituição</v-flex>
          </v-layout>
          <v-layout>
            <v-flex>VALOR TOTAL:</v-flex>
            <v-flex>R$ {{ valorTotal }} </v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>

          <v-layout>
            <v-flex>SALDO A RESTITUIR:</v-flex>
            <v-flex>R$ {{ valorRestituir }}</v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>

            <v-flex class="themeGrey--text body-2">
              CÁLCULO DA OPERAÇÃO: R$ {{ valorOperacao }}</v-flex
            >
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout row wrap v-if="page === 2">
        <v-layout column>
          <v-layout>
            <v-flex class="themeGrey--text" pb-3
              >Selecione o(s) item(ns) relacionado(s)</v-flex
            >
          </v-layout>
          <v-layout>
            <v-flex class="body-2"> SELECIONAR </v-flex>
            <v-flex class="body-2"> TIPO </v-flex>
            <v-flex class="body-2"> PRÊMIO TOTAL </v-flex>
            <v-flex class="body-2"> QTD. ÍTENS </v-flex>
            <v-flex class="body-2"> N. EMISSÃO ENDOSSO </v-flex>
            <v-flex class="body-2">N. ENDOSSO RESTITUIÇÃO</v-flex>
          </v-layout>
          <v-layout row column>
            <v-form v-model="page2RelacionavelDados">
              <v-layout
                row
                align-center
                wrap
                v-for="item in relacionavelList"
                :key="item.numeroRevisao"
              >
                    
                <v-flex class="checkbox" md1 >
                  <v-checkbox
                    class="check-endosso"
                    color="primary"
                    primary
                    hide-details
                    :value="
                      item && selected && item.numeroRevisao === selected.numeroRevisao
                    "
                    @change="(value) => (selected = value ? item : null)"
                    :disabled="selected && selected.numeroRevisao !== item.numeroRevisao"
                  ></v-checkbox>
                </v-flex>
  
                <v-flex md2 class="dados-restituicao">
                  {{ item.revisaoApolice === true ? "APÓLICE" : "ENDOSSO" }}
                </v-flex>
  
                <v-flex md2 align-center> R$ {{ item.totalPremio }} </v-flex>
  
                <v-flex md1 class="dados-restituicao">
                  {{ item.qtdItens }}
                </v-flex>
  
                <v-flex md3 class="dados-restituicao">
                  {{ item.numeroEndosso || "-" }}
                </v-flex>
  
                <v-flex md3 class="dados-restituicao">
                  {{ item.numeroEndossoRestituicao || "-" }}</v-flex
                >
              </v-layout>
            </v-form>
          </v-layout>
        </v-layout>
      </v-layout>

      <v-layout column row v-else-if="page === 3">
        <v-layout>
          <v-flex> Dados bancários do segurado </v-flex>
        </v-layout>
        <v-form
          ref="formulario"
          v-model="valid"
          lazy-validation
          grid-list-lg
          class="content"
        >
          <v-layout row wrap>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                mask="####"
                label="Cód. do Banco"
                v-model="dadosBancario.codigoBanco"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md5>
              <v-text-field
                label="Nome do Banco"
                v-model="dadosBancario.nomeBanco"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                mask="#####"
                label="Num. da Agência"
                v-model="dadosBancario.numeroAgencia"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                mask="##"
                label="Dígito da Agência"
                v-model="dadosBancario.digitoAgencia"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                mask="####################"
                label="Num. da Conta"
                v-model="dadosBancario.numeroConta"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md2>
              <v-text-field
                type="number"
                mask="##"
                label="Dígito da Conta"
                v-model="dadosBancario.digitoConta"
                required
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm5 md4>
              <v-select
                label="Tipo da Conta"
                v-model="dadosBancario.idTipoContaBancaria"
                item-text="titulo"
                item-value="id"
                :items="tipoContaBancariaList"
                required
              ></v-select>
            </v-flex>

            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-form>
      </v-layout>

      <v-layout column row v-else-if="page === 4">
        <v-layout>
          <v-flex xs12 sm5 md4>
            <v-select
              label="Motivo do Endosso"
              placeholder="Selecione uma opção"
              v-model="idMotivoEndosso"
              item-text="titulo"
              item-value="id"
              :items="motivoEndossoList"
              required
            ></v-select>
          </v-flex>
        </v-layout>

        <v-flex xs6>
          <v-textarea
            name="textarea"
            label="Breve descrição da operação (Texto Livre):"
            v-model="descricaoEndosso"
            background-color="white"
            :maxlength="250"
            counter="250"
          ></v-textarea>
        </v-flex>
      </v-layout>

      <v-layout column row v-else-if="page === 5">
        <v-layout>
          <v-flex> Resumo da operação </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm5 md2>
            <v-text-field
              label="Cód. do Banco"
              v-model="dadosBancario.codBanco"
              disabled
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5 md5>
            <v-text-field
              label="Nome do Banco"
              v-model="dadosBancario.nomeBanco"
              disabled
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5 md2>
            <v-text-field
              label="Num. da Agência"
              v-model="dadosBancario.numeroAgencia"
              disabled
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5 md2>
            <v-text-field
              label="Dígito da Agência"
              v-model="dadosBancario.digitoAgencia"
              disabled
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm5 md2>
            <v-text-field
              label="Num. da Conta"
              v-model="dadosBancario.numeroConta"
              disabled
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5 md2>
            <v-text-field
              label="Dígito da Conta"
              v-model="dadosBancario.digitoConta"
              disabled
            ></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5 md4>
            <v-select
              label="Tipo da Conta"
              v-model="dadosBancario.idTipoContaBancaria"
              item-text="titulo"
              item-value="id"
              :items="tipoContaBancariaList"
              required
              disabled
            ></v-select>
          </v-flex>

          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout>
          <v-flex class="primary--text body-2">
            VALOR A RESTITUIR: R$ {{ valorOperacao }}</v-flex
          >
        </v-layout>
      </v-layout>

      <v-layout row wrap v-else-if="page === 6">
        <v-layout wrap>
          <v-layout>
            <v-flex class="themeGrey--text" pb-3>Itens restituidos</v-flex>
          </v-layout>

          <v-flex class="body-2"> N. EMISSÃO ENDOSSO </v-flex>
          <v-flex class="body-2">N. ENDOSSO RESTITUIÇÃO</v-flex>
          <v-flex class="body-2"> VALOR </v-flex>
          <v-flex class="body-2"> QTD. ÍTENS </v-flex>
        </v-layout>
        <v-layout row column>
          <v-layout
            row
            align-center
            wrap
            v-for="item in restituivelList"
            :key="item.numeroRevisao"
          >
            <v-flex md3 class="dados-restituicao">
              {{ item.numeroEndosso || "-" }}
            </v-flex>

            <v-flex md3 class="dados-restituicao">
              {{ item.numeroEndossoRestituicao || "-" }}</v-flex
            >

            <v-flex md2 align-center> R$ {{ item.totalRestituicao }} </v-flex>

            <v-flex md1 class="dados-restituicao">
              {{ item.qtdItens }}
            </v-flex>
          </v-layout>
        </v-layout>

        <v-layout row column>
          <v-layout py-3>
            <v-flex class="themeGrey--text">Cálculo de restituição</v-flex>
          </v-layout>

          <v-layout>
            <v-flex>VALOR RESITITUIDO</v-flex>
            <v-flex>R$ {{ valorRestituir }}</v-flex>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-layout>
    </v-card-text>

    <v-card-actions class="px-5 pb-5">
      <v-spacer></v-spacer>
      <v-btn v-if="page === 1" color="primary" flat @click="fecharDialog"
        >CANCELAR
      </v-btn>
      <v-btn v-else color="primary" flat @click="page = page - 1"
        >VOLTAR
      </v-btn>
      <v-btn
        :disabled="valorOperacao <= 0"
        class="primary"
        @click="page = page + 1"
        v-if="page !== 3 && page < 2"
        >PRÓXIMO</v-btn
      >
      <v-btn
        class="primary"
        @click="page = page + 1"
        :disabled="selected === null"
        v-if="page === 2"
        >PRÓXIMO</v-btn
      >
      <v-btn
        :disabled="!valid"
        class="primary"
        @click="validaCampos"
        v-else-if="page === 3"
        >PRÓXIMO</v-btn
      >
      <v-btn v-else-if="page === 4" class="primary" :disabled="idMotivoEndosso === null || !descricaoEndosso" @click="dialogConfirmacao = true"
        >EMITIR PAGAMENTO</v-btn
      >
    </v-card-actions>

    
      <div class="text-xs-center">
        <v-dialog v-model="dialogConfirmacao" width="500">
          <v-card>
            <v-card-title class="primary">
              <span class="headline"> EMITIR PAGAMENTO</span>
            </v-card-title>

            <v-card-text>
              Tem certeza de que deseja emitir o pagamento ao segurado?
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogConfirmacao = false"
                >VOLTAR
              </v-btn>
              <v-btn class="primary" flat @click="enviar"> Confirmar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
       <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
    
   
  </v-card>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalRestituicao",
  data: () => {
    return {
      listaEscolhido: [], 
      dialogConfirmacao: false,
      idApolice: null,
      page: 1,
      snack: false,
      checkboxSelection: [],
      snackColor: "",
      snackText: "",
      page2RelacionavelDados: true,
      valid: true,
      restituivelList: [],
      relacionavelList: [],
      tipoContaBancariaList: [],
      dadosBancario: {
        codigoBanco: null,
        nomeBanco: null,
        numeroAgencia: null,
        digitoAgencia: null,
        numeroConta: null,
        digitoConta: null,
        idTipoContaBancaria: 1,
      },
      motivoEndossoList: [],
      selectedRestituivelLength: 0,
      selected: null,
      idMotivoEndosso: null,
      descricaoEndosso: null,
      descricaoEndossoDisabled: true,
      veiculoList: [],
      regras: {
        notNull: [ v => !!v || "Você não pode deixar este campo em branco"],
        checkBoxNotNull: [ v => !v.length > 0 || "Você precisa selecionar um dos campos"]
       
      },
    };
  },
  props: { dialog: Boolean },
  computed: {
    habilitarCheckbox() {
      let contagemSelected = 0;
      this.restituivelList.forEach(element => {
        if(element.selected == true) {
          contagemSelected++;
        }
      })
      return contagemSelected > 0;
    },
    
    valorTotal() {
      return this.restituivelList.reduce(
        (acc, cur) => acc + (cur.totalRestituicao || 0),
        0
      );
    },
    valorOperacao() {
      return this.restituivelList.reduce(
        (acc, cur) => (cur.selected ? acc + (cur.totalRestituicao || 0) : acc),
        0
      );
    },
    valorRestituir() {
      return this.restituivelList.reduce(
        (acc, cur) =>
          cur.restituido === false ? acc + (cur.totalRestituicao || 0) : acc,
        0
      );
    },
    checkCheckbox() {
      return this.relacionavelList.filter(item => item.selected === true).length;
    }
    
  },
  mounted() {
    this.idApolice = parseInt(this.$route.query.id);
    this.listarRestituiveis();
    this.buscarOpcoesContaBancaria();
    this.buscarOpcoesMotivoEndosso();
  },
  watch: {
    dialog(value) {
      if (value) {
        this.page = 1;
        this.restituivelList = [];
        this.relacionavelList = [];
        this.selected = null;
        this.idMotivoEndosso = null;
        this.descricaoEndosso = null;
        this.dialogConfirmacao = false;
        this.dadosBancario = {
          codigoBanco: null,
          nomeBanco: null,
          numeroAgencia: null,
          digitoAgencia: null,
          numeroConta: null,
          digitoConta: null,
          idTipoContaBancaria: 1,
        };
        this.listarRestituiveis();
      }
    },
    page(value) {
      if (value === 2) {
        this.listarRelacionaveis();
      }
    },
  },
  methods: {
    verificarItemMesmo(item) {
      let nrItemSelecionado = null;
      this.restituivelList.forEach(element => {
        if(element.selected == true) {
          nrItemSelecionado = element.numeroRevisao;
        }
      });
      return nrItemSelecionado == item;
    },
    salvarNumeroRevisao(nr) {
      this.nrItemSelecionado = nr;
    },
    
    setDisabledProximoPage2(){
      this.selected = !this.selected
    },
    validaCampos() {
      if (this.$refs.formulario.validate()) {
        this.page = 4;
      }
    },
    listarRestituiveis() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listarRestituiveis/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.restituivelList = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    listarRelacionaveis() {
      axios
        .get(
          `${process.env.URL_ENDOSSOMS}/v1/listarRelacionaveis/${this.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then((response) => {
          this.relacionavelList = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    buscarOpcoesContaBancaria() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/tipoContaBancaria`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          this.tipoContaBancariaList = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    buscarOpcoesMotivoEndosso() {
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/motivoEndosso`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          this.motivoEndossoList = response.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    buscarListaVeiculos() {
      const params = new URLSearchParams({
        idApolice: this.idApolice,
        numeroRevisaoList: this.selected.numeroRevisao,
      });
      return axios
        .get(`${process.env.URL_APOLICEMS}/v1/apoliceItemInfoList?${params}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
          },
        })
        .then((response) => {
          return (this.veiculoList = response.data);
        })
        .catch((err) => {
          throw err;
        });
    },

    listaSelecionados(list) {
      return list
        .filter((item) => item.selected)
        .map((item) => item.numeroRevisao);
    },

    async comporDescricao() {
      try {
        this.descricaoEndossoDisabled = true;
        this.descricaoEndosso = "Carregando...";
        await this.buscarListaVeiculos();
        const apolice = this.relacionavelList.find(
          (item) => item.revisaoApolice
        );
        const numeroApolice = apolice ? apolice.numeroEndosso : "";

        const endossos = this.selected;

        const placas = this.veiculoList.map((item) => item.placa).join("\n");

        this.descricaoEndosso = `Número da Apólice: ${numeroApolice}\nRestituição do(s) endosso(s): ${endossos}\n\nItens a restituir:\n${placas}`;
      } catch (error) {
        this.descricaoEndosso = "";
      } finally {
        this.descricaoEndossoDisabled = false;
      }
    },
    endossoRestituido() {      
      return {
        idTipoEndosso: 2,
        dadosBancarios: {
          codigoBanco: this.dadosBancario.codigoBanco,
          nomeBanco: this.dadosBancario.nomeBanco,
          numeroAgencia: this.dadosBancario.numeroAgencia,
          digitoAgencia: this.dadosBancario.digitoAgencia,
          numeroConta: this.dadosBancario.numeroConta,
          digitoConta: this.dadosBancario.digitoConta,
          tipoContaBancaria: { id: this.dadosBancario.idTipoContaBancaria },
        },
        idMotivoEndosso: this.idMotivoEndosso,
        textoLivreEndosso: this.descricaoEndosso,
        numeroRevisaoRestituido: this.listaSelecionados(
          this.restituivelList
        ).join(),
        numeroRevisaoRelacionado: this.selected.numeroRevisao
      };
    },

    enviar() {
      this.$store.commit("startLoading");      
      axios
        .post(
          `${process.env.URL_ENDOSSOMS}/v1/emitirEndosso/${this.idApolice}`,
          this.endossoRestituido(),
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`,
            },
          }
        )
        .then(() => {
          this.save();
          setTimeout(() => {
            this.fecharDialog();
            this.$emit("atualizar");
            this.$router.push("/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice);
          }, 1000);
        })
        .catch(error => {
          this.dialogConfirmacao = false;
          this.snack = true;
          this.snackColor= "error"
          this.snackText = error.response.data.message;
        });
        this.$store.commit("endLoading");      
    },

    fecharDialog() {
      this.$emit("fecharDialog");
    },

    save() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Item salvo";
    },
  },
};
</script>

<style scoped>
.check-endosso {
  margin-top: 0px;
  display: flex;
  align-items: center;
}

.dados-restituicao {
  margin-top: 5px;
  text-align: center;
}

.checkbox {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 25px;
}

.headline {
  color: #fff
}
</style>


// WEBPACK FOOTER //
// src/components/pages/frota/ModalRestituicao.vue